'use strict';

import Parameter from '../Parameter';

/**
 * Body parameter
 */
class BodyParameter extends Parameter {

}

export default BodyParameter;
